import * as constants from "./actionTypes";
import * as common from "./commonActions";

import Axios from '../axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleAPIError } from '../utility/actionHelper'

export function successRequestingGetCoaches(response, append = false) {
  if (response.status === 200) {
    return {
      type: constants.ADD_COACHES,
      coaches: response.data.coaches,
      pages: response.data.meta?.pagination?.total_pages || 1,
      pagination: response.data.meta?.pagination,
      append,
    }
  } else {
    console.log("ERROR ON SIGNIN");
    return { type: constants.UI_ERROR, error: response.data };
  }
}

// export function successRequestingSyncMailChimp(response){
//   if(response.status === 200){
//     return { type: constants.SYNC, coaches: response.data.sync};
//   }else{
//     console.log("ERROR ON SYNCING MAILCHIMP")
//     return {type: constants.UI_ERROR, error: response.data}
//   }
// }

export function successRequestingCreateCoach(response) {
  if (response.status === 201) {
    return { type: constants.CREATE_COACH, coach: response.data.user };
  } else {
    console.log("ERROR ON SIGNIN");
    return { type: constants.UI_ERROR, error: response.data };
  }
}

export function successRequestingUpdateCoach(response) {
  if (response.status === 200) {
    return { type: constants.UPDATE_COACH, coach: response.data.user };
  } else {
    console.log("ERROR ON SIGNIN");
    return { type: constants.UI_ERROR, error: response.data };
  }
}

export function successRequestingUpdateAdminCoach(response) {
  if (response.status === 200) {
    return { type: constants.UPDATE_COACH, coach: response.data.coach }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

export function successRequestingInviteCoach(response) {
  if (response.status === 200 || response.status === 201) {
    return { type: constants.CREATE_COACH, coach: response.data.coach }
  } else {
    return { type: constants.UI_ERROR, error: response.data }
  }
}

export function successAddingStudentEnrollment(response) {
  if (response.status === 200 || response.status === 201) {
    return {
      type: constants.GET_COURSE,
      course: response.data.course,
      enrollment: response.data.enrollment,
    };
  } else {
    console.log("ERROR ON ADDING FAMILY ENROLLMENT");
    return { type: constants.UI_ERROR, error: response.data };
  }
}

export function successRemovingStudentEnrollment(response) {
  if (response.status === 200 || response.status === 201) {
    return {
      type: constants.REMOVE_STUDENTS,
      enrollment: response.data.enrollment,
      course: response.data.course,
    };
  } else {
    console.log("ERROR ON ADDING FAMILY ENROLLMENT");
    return { type: constants.UI_ERROR, error: response.data };
  }
}

// THUNKS HERE
export function getCoaches(searchTerm, page = 1, perPage = 25, status = null, append = false) {
  return function (dispatch) {
    return requestGetCoaches(searchTerm, page, perPage, status).then((response) =>
      dispatch(successRequestingGetCoaches(response, append))
    )
  }
}

// export function SyncMailChimp(){
//   return function(dispatch){
//     dispatch(common.loadingChanged(true));
//     return requestSyncMailChimp().then(
//       response => dispatch(successRequestingSyncMailChimp(response))
//     ).then(
//       turnOffSpinner => dispatch(common.loadingChanged(false))
//     )
//   }
// }

export function createCoach(coach) {
  return function (dispatch) {
    dispatch(common.loadingChanged(true));
    return requestCreateCoach(coach)
      .then((response) => dispatch(successRequestingCreateCoach(response)))
      .then((turnOffSpinner) => dispatch(common.loadingChanged(false)));
  };
}

export function updateCoach(coach) {
  return function (dispatch) {
    dispatch(common.loadingChanged(true));
    return requestUpdateCoach(coach)
      .then((response) => dispatch(successRequestingUpdateCoach(response)))
      .then((turnOffSpinner) => dispatch(common.loadingChanged(false)));
  };
}

export function adminUpdateCoach(coach) {
  return function (dispatch) {
    dispatch(common.loadingChanged(true))
    return requestAdminUpdateCoach(coach)
      .then((response) => dispatch(successRequestingUpdateAdminCoach(response)))
      .then(() => dispatch(common.loadingChanged(false)))
  }
}

export function inviteCoach(inviteData) {
  return function (dispatch) {
    dispatch(common.loadingChanged(true))
    return requestInviteCoach(inviteData)
      .then((response) => dispatch(successRequestingInviteCoach(response)))
      .then(() => dispatch(common.loadingChanged(false)))
  }
}

export function reinviteCoach(coachId) {
  return requestReinviteCoach(coachId)
}

export function getCoachCareerStats(coachId) {
  return requestCoachCareerStats(coachId)
}

export function removeStudentEnrollment(enrollment_id, course) {
  return function (dispatch) {
    dispatch(common.loadingChanged(true));

    return requestRemoveStudentEnrollment(enrollment_id, course)
      .then((response) => dispatch(successRemovingStudentEnrollment(response)))
      .then((turnOffSpinner) => dispatch(common.loadingChanged(false)));
  };
}

// API CALLS

function requestGetCoaches(searchTerm, page = 1, perPage = 25, status = null) {
  let requestUrl = '/api/v1/admin/coaches'
  const params = new URLSearchParams()

  if (searchTerm) {
    params.append('search', searchTerm)
  }

  params.append('page', page)
  params.append('per_page', perPage)
  if (status) {
    params.append('status', status)
  }

  requestUrl += `?${params.toString()}`
  return Axios.get(requestUrl)
}

// function requestSyncMailChimp(){
//   let requestUrl = '/api/v1/sync'
//   return Axios.get(requestUrl)
// }

function requestCreateCoach(coach) {
  const requestUrl = '/api/v1/admin/users'
  return Axios.post(requestUrl, {
    type: coach.type,
    first_name: coach.first_name,
    last_name: coach.last_name,
    email: coach.email,
    password: coach.password,
    community_id: coach.community_id,
    gender: coach.gender,
    birthdate: coach.birthdate,
  })
}

function requestUpdateCoach(coach) {
  let requestUrl = "/api/v1/users/" + coach.id + "/";
  return Axios.put(requestUrl, {
    first_name: coach.first_name,
    last_name: coach.last_name,
    email: coach.email,
    password: coach.password,
    current_password: coach.current_password,
    ...(coach.gender && { gender: coach.gender }),
    //community_id: coach.community_id
  });
}

function requestAdminUpdateCoach(coach) {
  const requestUrl = `/api/v1/admin/coaches/${coach.id}`

  return Axios.put(requestUrl, { user_accolades_attributes: coach.user_accolades_attributes })
}

function requestInviteCoach(inviteData) {
  const requestUrl = '/api/v1/admin/coach/invitations'

  return Axios.post(requestUrl, {
    first_name: inviteData.first_name,
    last_name: inviteData.last_name,
    email: inviteData.email,
    phone: inviteData.phone,
    phone_prefix: inviteData.phone_prefix,
    phone_prefix_country: inviteData.phone_prefix_country,
    birthdate: inviteData.birthdate,
    gender: inviteData.gender,
    community_id: inviteData.community_id,
  })
}

function requestReinviteCoach(coachId) {
  const requestUrl = `/api/v1/admin/coach/invitations/${coachId}`
  return Axios.put(requestUrl)
}

function requestCoachCareerStats(coachId) {
  const requestUrl = `/api/v1/coaches/${coachId}/career_stats`
  return Axios.get(requestUrl)
}

function requestRemoveStudentEnrollment(enrollment_id, course) {
  // let requestUrl = '/api/v1/enrollments/' + enrollment_id;
  // return Axios.delete(requestUrl);
  let requestUrl = "/api/v1/enrollments/" + enrollment_id;
  return Axios.delete(requestUrl);
  // return Axios.put(requestUrl, {
  //   course_id: null
  // });
}

export const requestMakeLeadCoach = (id) => Axios.post(`api/v1/users/${id}/make_lead_coach`)
